import { FileExclamationOutlined } from '@ant-design/icons'
import { FC } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentUnsupportedMetaLabel,
  getCrmIntegrationAttachmentKindLabel,
  resolveCrmIntegrationAttachmentUrlForDisplay,
} from '../../lib/crmIntegrationAttachment'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingUnsupportedAttachmentProps = {
  att: CrmIntegrationAttachment
}

const CrmIntegrationIncomingUnsupportedAttachment: FC<
  CrmIntegrationIncomingUnsupportedAttachmentProps
> = ({ att }) => {
  const title = getCrmIntegrationAttachmentKindLabel(att)
  const metaLabel = attachmentUnsupportedMetaLabel(att)
  const href = resolveCrmIntegrationAttachmentUrlForDisplay(att.url)

  return (
    <div className={classes.bubbleUnsupportedCard}>
      <div className={classes.bubbleUnsupportedHeader}>
        <FileExclamationOutlined
          className={classes.bubbleUnsupportedIcon}
          aria-hidden
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
        <div className={classes.bubbleUnsupportedMeta}>
          <span className={classes.bubbleUnsupportedTitle}>{title}</span>
          {metaLabel ? (
            <span className={classes.bubbleUnsupportedSubtitle}>{metaLabel}</span>
          ) : null}
        </div>
      </div>
      {href ? (
        <a
          className={classes.bubbleAttachmentLink}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={att.name ?? undefined}
        >
          Открыть
        </a>
      ) : (
        <span className={classes.bubbleUnsupportedHint}>
          Формат не поддерживается
        </span>
      )}
    </div>
  )
}

export default CrmIntegrationIncomingUnsupportedAttachment
